import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';

@Component({
  selector: 'app-sso-logout-modal',
  templateUrl: './sso-logout-modal.component.html',
  styleUrls: ['./sso-logout-modal.component.css']
})
export class SsoLogoutModalComponent implements OnInit {

  rootScopeData:RootScopeDeclare;

  @Output() onsignout: EventEmitter<string> = new EventEmitter();
  autoLogoOutMsgAfterUserInfoUpdate: false;
  constructor(private rootScopeService:RootScopeService) { }
  @Output() onClose:EventEmitter<string>=new EventEmitter();
  ngOnInit() {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData =>
      { this.rootScopeData = rootScopeData;

    });
  }
  autoLogout(){
    localStorage.setItem("islfcpartswebsiteLinked", "true");
    localStorage.setItem("userID", this.rootScopeData.currentUser.userId+"");
    if (localStorage.getItem("newEquipmentAdded")) {
      localStorage.removeItem("newEquipmentAdded");
      }
      this.onsignout.emit();
  }


}
